//#region components/empty_state/empty_state_constants.js
var e = {
	200: "d-empty-state--size-sm",
	300: "d-empty-state--size-md",
	400: "d-empty-state--size-lg",
	sm: "d-empty-state--size-sm",
	md: "d-empty-state--size-md",
	lg: "d-empty-state--size-lg"
}, t = {
	200: "d-empty-state__content--sm",
	300: "d-empty-state__content--md",
	400: "d-empty-state__content--lg",
	sm: "d-empty-state__content--sm",
	md: "d-empty-state__content--md",
	lg: "d-empty-state__content--lg"
}, n = {
	200: "md",
	300: "xl",
	400: "2xl",
	sm: "md",
	md: "xl",
	lg: "2xl"
}, r = {
	200: "200",
	300: "200",
	400: void 0,
	sm: "200",
	md: "200",
	lg: void 0
}, i = {
	200: "sm",
	300: "md",
	400: "lg",
	sm: "sm",
	md: "md",
	lg: "lg"
}, a = {
	200: void 0,
	300: "300",
	400: "300",
	sm: void 0,
	md: "300",
	lg: "300"
}, o = {
	EMPTY_STATE_SIZE_MODIFIERS: e,
	EMPTY_STATE_CONTENT_SIZE_MODIFIERS: t,
	EMPTY_STATE_HEADLINE_SIZES: n,
	EMPTY_STATE_HEADLINE_DENSITIES: r,
	EMPTY_STATE_BODY_SIZES: i,
	EMPTY_STATE_BODY_DENSITIES: a
};
//#endregion
export { a as EMPTY_STATE_BODY_DENSITIES, i as EMPTY_STATE_BODY_SIZES, t as EMPTY_STATE_CONTENT_SIZE_MODIFIERS, r as EMPTY_STATE_HEADLINE_DENSITIES, n as EMPTY_STATE_HEADLINE_SIZES, e as EMPTY_STATE_SIZE_MODIFIERS, o as default };

//# sourceMappingURL=empty-state-constants.js.map